import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsOfUseComponent } from './terms-of-use.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { MatCardModule, MatCheckboxModule, MatExpansionModule, MatIconModule } from '@angular/material';
import {MatRippleModule} from '@angular/material/core';
import { TermsViewComponent } from './terms-view/terms-view.component';
import { TermsViewService } from './terms-view/terms-view.service';
import { PacViewComponent } from './pac-view/pac-view.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatCardModule,
    MatRippleModule,
    MatIconModule,
    MatCheckboxModule,
    MatExpansionModule,
  ],
  declarations: [
    TermsOfUseComponent,
    TermsViewComponent,
    PacViewComponent
  ],
  exports: [
    TermsOfUseComponent
  ],
  providers: [
    TermsViewService
  ]
})
export class TermsOfUseModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/terms-of-use/terms-of-use.module.ts